<template>
  <div
    class="ddrow"
    :class="{ 'ddrow-exp': d.expired }"
    :style="{ borderInlineStartColor: d.color }"
    @click="$emit('select', device)"
  >
    <div class="dd-top">
      <div
        class="dd-ava"
        :style="{ background: d.color }"
      >
        <v-icon
          color="#fff"
          size="19"
        >
          {{ d.avatarIcon }}
        </v-icon>
      </div>
      <div class="dd-main">
        <div class="dd-nm">
          {{ device.title }}
        </div>
        <div class="dd-ow">
          {{ ownerName }}
        </div>
      </div>

      <span
        v-if="d.expired"
        class="dd-pill dd-pill-red"
      >
        <v-icon
          size="13"
          color="#9a2a2b"
        >mdi-alert-circle-outline</v-icon> منقضی
      </span>
      <button
        v-else
        ref="setBtn"
        class="dd-setbtn"
        :class="{ open: menuOpen }"
        @click.stop="toggleMenu"
      >
        <v-icon size="15">mdi-cog</v-icon> تنظیمات
        <v-icon size="14">mdi-chevron-down</v-icon>
      </button>
    </div>

    <div
      v-if="!d.expired"
      class="dd-ind"
    >
      <span
        class="dd-tag"
        :class="d.online ? 'ddt-green' : 'ddt-gray'"
      >
        <v-icon size="14">{{ d.online ? 'mdi-access-point' : 'mdi-access-point-network-off' }}</v-icon>
        <b>{{ d.online ? 'آنلاین' : 'آفلاین' }}</b>
      </span>
      <span
        class="dd-tag"
        :class="moveCls"
      >
        <v-icon size="14">{{ d.move.icon }}</v-icon>{{ d.move.label }}
      </span>
      <span
        class="dd-tag"
        :class="d.loc.cls"
      >
        <v-icon size="14">{{ d.loc.icon }}</v-icon>{{ d.loc.label }}
      </span>
    </div>

    <div class="dd-meta">
      <span><v-icon size="13">mdi-identifier</v-icon> شناسه: <code>{{ device.imei }}</code></span>
      <span v-if="device.sim"><v-icon size="13">mdi-sim</v-icon> سیم‌کارت: <code>{{ device.sim }}</code></span>
      <span><v-icon size="13">mdi-clock-outline</v-icon> آخرین بروزرسانی: {{ lastUpdateText }}</span>
    </div>

    <div
      v-if="d.expired"
      class="dd-renew"
    >
      <span class="dd-renew-txt">برای ادامهٔ ردیابی اشتراک را تمدید کنید</span>
      <button
        class="dd-renewbtn"
        @click.stop="$emit('renew', device)"
      >
        <v-icon
          size="15"
          color="#fff"
        >mdi-refresh</v-icon> تمدید اکانت
      </button>
    </div>

    <div
      v-show="menuOpen"
      ref="menuEl"
      class="dd-menu"
      :style="menuStyle"
      @click.stop
    >
      <button
        v-for="(row, i) in menuItems"
        :key="i"
        class="dd-menuitem"
        @click.stop="onAction(row)"
      >
        <v-icon size="17">{{ row.icon }}</v-icon> {{ row.title }}
      </button>
    </div>
  </div>
</template>

<script>
import { deviceDisplay } from '@/utils/deviceDisplay'

export default {
  name: 'DeviceRow',
  props: {
    device: { type: Object, required: true },
    menuItems: { type: Array, default: () => [] },
  },
  data() {
    return { menuOpen: false, menuStyle: {} }
  },
  computed: {
    d() {
      return deviceDisplay(this.device)
    },
    ownerName() {
      const u = this.device && this.device.userId
      if (u && typeof u === 'object') return `${u.name || ''} ${u.family || ''}`.trim()
      return ''
    },
    moveCls() {
      return {
        move: 'ddt-green', idle: 'ddt-green', park: 'ddt-amber', tow: 'ddt-red', off: 'ddt-gray',
      }[this.d.kind] || 'ddt-gray'
    },
    lastUpdateText() {
      const st = (this.device.serverStatus && this.device.serverStatus.servertime) || 0
      const po = (this.device.serverInfo && this.device.serverInfo.servertime) || 0
      const t = Math.max(st, po)
      if (!t || t < 1000) return 'نامشخص'
      const fa = n => String(n).replace(/[0-9]/g, dd => '۰۱۲۳۴۵۶۷۸۹'[dd])
      let s = Math.floor(Date.now() / 1000) - t
      if (s < 0) s = 0
      if (s < 60) return `${fa(s)} ثانیه پیش`
      if (s < 3600) return `${fa(Math.floor(s / 60))} دقیقه پیش`
      if (s < 86400) return `${fa(Math.floor(s / 3600))} ساعت پیش`
      return `${fa(Math.floor(s / 86400))} روز پیش`
    },
  },
  mounted() {
    // منو را به body منتقل می‌کنیم تا زیرِ نقشه/عناصرِ دیگر نرود و بریده نشود
    if (this.$refs.menuEl && this.$refs.menuEl.parentNode !== document.body) {
      document.body.appendChild(this.$refs.menuEl)
    }
  },
  beforeDestroy() {
    this.detachClose()
    const el = this.$refs.menuEl
    if (el && el.parentNode) el.parentNode.removeChild(el)
  },
  methods: {
    toggleMenu() {
      if (this.menuOpen) { this.closeMenu(); return }
      this.menuOpen = true
      this.$nextTick(() => {
        const btn = this.$refs.setBtn
        if (!btn) return
        const r = btn.getBoundingClientRect()
        const menuW = 220
        const menuH = Math.min(360, 42 * this.menuItems.length + 12)
        let left = r.right - menuW
        if (left < 8) left = 8
        if (left + menuW > window.innerWidth - 8) left = window.innerWidth - menuW - 8
        let top = r.bottom + 4
        if (top + menuH > window.innerHeight - 8) top = Math.max(8, r.top - menuH - 4)
        this.menuStyle = { top: `${top}px`, left: `${left}px`, width: `${menuW}px` }
        setTimeout(() => {
          document.addEventListener('click', this.closeMenu)
          window.addEventListener('scroll', this.closeMenu, true)
          window.addEventListener('resize', this.closeMenu)
        }, 0)
      })
    },
    closeMenu() {
      this.menuOpen = false
      this.detachClose()
    },
    detachClose() {
      document.removeEventListener('click', this.closeMenu)
      window.removeEventListener('scroll', this.closeMenu, true)
      window.removeEventListener('resize', this.closeMenu)
    },
    onAction(row) {
      this.closeMenu()
      this.$emit('action', { action: row.action, device: this.device })
    },
  },
}
</script>

<style scoped>
.ddrow{position:relative;padding:9px 12px;border-bottom:1px solid #ebe9f1;border-inline-start:3px solid transparent;cursor:pointer}
.ddrow:hover{background:#faf9ff}
.ddrow-exp{background:#fff7f7}
.dd-top{display:flex;align-items:center;gap:9px}
.dd-ava{width:36px;height:36px;border-radius:50%;display:flex;align-items:center;justify-content:center;flex:none}
.dd-main{flex:1;min-width:0}
.dd-nm{font-weight:700;font-size:13.5px;line-height:1.3;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}
.dd-ow{font-size:11.5px;color:#6e6b7b;line-height:1.3;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}
.ddrow-exp .dd-ow{color:#9a2a2b}
.dd-setbtn{display:inline-flex;align-items:center;gap:4px;padding:5px 9px;border-radius:8px;border:1px solid #d8d6e0;background:#fff;color:#2f2b3d;font-size:12px;font-family:inherit;white-space:nowrap;cursor:pointer;flex:none}
.dd-setbtn:hover,.dd-setbtn.open{background:#f6f5ff;border-color:#c9c4f5}
.dd-pill{display:inline-flex;align-items:center;gap:4px;font-size:11.5px;padding:3px 8px;border-radius:20px;flex:none}
.dd-pill-red{background:#fde6e6;color:#9a2a2b}
.dd-ind{display:flex;flex-wrap:wrap;gap:6px;margin-top:7px}
.dd-tag{display:inline-flex;align-items:center;gap:4px;font-size:11.5px;padding:3px 8px;border-radius:7px;background:#f4f4f8;color:#5b5b5b;max-width:100%}
.dd-tag b{font-weight:700}
.ddt-green{background:#e5f8ee;color:#1b7a44}
.ddt-amber{background:#fff2e2;color:#9a5a10}
.ddt-red{background:#fde6e6;color:#9a2a2b}
.ddt-gray{background:#eef0f2;color:#5b5b5b}
.dd-meta{display:flex;flex-wrap:wrap;gap:3px 14px;margin-top:7px;font-size:11px;color:#6e6b7b}
.dd-meta code{font-family:inherit;direction:ltr;unicode-bidi:embed;color:#5b5b5b}
.dd-meta .v-icon{vertical-align:-2px;color:#9aa0ac}
.dd-ind .v-icon{vertical-align:-2px}
.dd-renew{display:flex;align-items:center;justify-content:space-between;gap:8px;margin-top:7px;flex-wrap:wrap}
.dd-renew-txt{font-size:11.5px;color:#9a2a2b}
.dd-renewbtn{display:inline-flex;align-items:center;gap:5px;padding:5px 11px;border-radius:8px;border:none;background:#ea5455;color:#fff;font-size:11.5px;font-family:inherit;cursor:pointer}
.dd-menu{position:fixed;z-index:99999;background:#fff;border:1px solid #ebe9f1;border-radius:10px;box-shadow:0 8px 24px rgba(0,0,0,.16);padding:6px;display:flex;flex-direction:column;gap:2px}
.dd-menuitem{display:flex;align-items:center;gap:8px;font-size:13px;padding:8px 10px;border:none;border-radius:8px;background:#fff;color:#2f2b3d;font-family:Vazirmatn,Tahoma,sans-serif;cursor:pointer;text-align:start;width:100%}
.dd-menuitem:hover{background:#f6f5ff}
.dd-menuitem .v-icon{color:#5e50ee}
</style>
